import { render, staticRenderFns } from "./HotSearchList.vue?vue&type=template&id=4e12499c&"
import script from "./HotSearchList.vue?vue&type=script&lang=js&"
export * from "./HotSearchList.vue?vue&type=script&lang=js&"
import style0 from "./HotSearchList.vue?vue&type=style&index=0&id=4e12499c&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports